import { render, staticRenderFns } from "./shipperManagement.vue?vue&type=template&id=1f08c452&scoped=true&"
import script from "./shipperManagement.vue?vue&type=script&lang=js&"
export * from "./shipperManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08c452",
  null
  
)

component.options.__file = "shipperManagement.vue"
export default component.exports